import styled from "@emotion/styled";
import { getIn, useFormikContext } from "formik";

import { Icon } from "../icons";
import { FONT_WEIGHT_NORMAL } from "../utilities";
import { useFieldContext } from "./FormFieldContext";

const Alert = styled.div`
  // Span the full width when inside an inline-label grid row; ignored elsewhere.
  grid-column: 1 / -1;
  background: ${({ theme }) => theme.errorContainer};
  color: ${({ theme }) => theme.error};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 6px 8px;
  font-weight: ${FONT_WEIGHT_NORMAL};
  font-size: inherit;
  i {
    font-size: 14px;
  }
`;

export const FieldValidationErrorMessage = () => {
  const { name } = useFieldContext();
  // Read from form state rather than useField: useField re-registers the field
  // and would overwrite a sibling input's field-level validate with undefined.
  const { errors, touched } = useFormikContext();
  const error = getIn(errors, name);
  const isTouched = getIn(touched, name);
  if (!error || !isTouched) {
    return null;
  }
  return (
    <Alert>
      <Icon icon="exclamation-circle" />
      <span>{error}</span>
    </Alert>
  );
};
